import React, { useEffect, useState } from "react";
import Hero from "../components/Hero";
import Calculator from "../components/Calculator";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

const Home = () => {
  const [resultContext, setResultContext] = useState(null);

  useEffect(() => {
    const onResult = (e) => setResultContext(e.detail);
    window.addEventListener("ourigen:result", onResult);
    return () => window.removeEventListener("ourigen:result", onResult);
  }, []);

  const scrollToCalc = () => {
    document.getElementById("calculator")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="home-page">
      <Hero onStart={scrollToCalc} />
      <Calculator />
      <ContactForm resultContext={resultContext} />
      <Footer />
    </div>
  );
};

export default Home;
